import Component from '../core/Component';

export default class Loading {
    activeClass = 'loading--show';
    element;

    constructor(element) {
        let el = element;

        if (!el) {
           el = document.getElementsByClassName('loading')[0];
        }

        this.element = el;
    }

    show() {
        const el = this.element;

        if (el) {
            el.classList.add(this.activeClass);
        }
    }

    hide() {
        const el = this.element;

        if (el) {
            el.classList.remove(this.activeClass)
        }
    }
}